const user = {
  getlist: 'user/getlist',
  add: 'user/add',
  update: 'user/update-by-admin',
  remove: 'user/remove',
  get: 'user/get-by-admin',
  bodyHistory: 'userbodyhistory/getlist-by-admin',
  userbodyhistorycalculate: 'userbodyhistory/calculate-by-admin',
  userLanguage: 'user/set-language-by-admin',
  userNotifications: 'notificationsetting/getlist',
  addUserBodyHistory: 'userbodyhistory/add'
}
export default user
